import { render, staticRenderFns } from "./DefaultValues.vue?vue&type=template&id=39fcd61e&scoped=true&"
import script from "./DefaultValues.vue?vue&type=script&lang=js&"
export * from "./DefaultValues.vue?vue&type=script&lang=js&"
import style0 from "./DefaultValues.vue?vue&type=style&index=0&id=39fcd61e&prod&scoped=true&lang=css&"
import style1 from "./DefaultValues.vue?vue&type=style&index=1&id=39fcd61e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fcd61e",
  null
  
)

export default component.exports